'use client';

import React from 'react';
import ReactPlayer from 'react-player';

export default function Video({ url }) {
	return (
		<div className="w-full h-auto">
			<ReactPlayer url={url} width="100%" controls />
		</div>
	);
}
